import { h, Fragment } from 'vue';

import type { IInternalItem, TFilterMath } from '@components/composable';

interface IHighlightProps {
  isPure: boolean;
  item: IInternalItem;
  matches: TFilterMath | undefined;
  length: number;
  name: string;
}

export function CdsHighlight(props: IHighlightProps) {
  const text = h('span', {}, props.item.title);

  if (props.isPure) return text;
  if (props.matches == null) return text;
  if (Array.isArray(props.matches)) throw new Error('Multiple matches are not supported');

  return typeof props.matches === 'number' && ~props.matches
    ? h(Fragment, {}, [
        h('span', { class: `cds-${props.name}__unmask` }, props.item.title.substr(0, props.matches)),
        h('span', { class: `cds-${props.name}__mask` }, props.item.title.substr(props.matches, props.length)),
        h('span', { class: `cds-${props.name}__unmask` }, props.item.title.substr(props.matches + props.length))
      ])
    : text;
}
